module.exports = __webpack_public_path__ + "static/media/tiny_img_2.e2960caa.png";